// Module
var code = "<div class=\"multiselect-list\"> <user-pill v-for=\"v in value\" :key=\"v\" :value=\"v\" :show-remove=\"showRemove\" @remove=\"remove\"> </user-pill> </div> ";
// Exports
export default code;